/**
    热卖商品
**/
<template>
  <div class="favoritGoods" v-if="favoritGoodsList.length>0?true:false">
    <div class="enjoy_title">
        <h3>猜你喜欢</h3>
      </div>
      <div class="no_enough">
        <ul>
          <li class="opacity_img1" v-for="item in favoritGoodsList" :key="item.id">
            <a href="javascript:;">
              <div class="p_img" style="overflow: hidden;">
                <!-- <img src="images/no_enough1.jpg" /> -->
                <router-link :to="stype==2?`/goodsdetail?id=${item.id}`:`/goodsDetail_supplie?id=${item.id}`">
                <el-image
                    class="img-responsive selectItemCss_ls"
                    :src="`${item.photos}`"
                    style="display: block"
                ></el-image>
                </router-link>
              </div>
              <router-link :to="stype==2?`/goodsdetail?id=${item.id}`:`/goodsDetail_supplie?id=${item.id}`">
                <div
                  class="no_ename"
                  :title="item.name"
                >
                  {{item.name}}
                </div>
              </router-link>
              <div class="no_eprice"><em>¥</em>{{item.realprice!=-1?item.realprice:'面议'}}</div>
            </a>
          </li>
        </ul>
      </div>
  </div>
</template>
<script>
import { recommendFavorit} from "@/api/xunyou";
import "@/assets/css/style.css";
export default {
  data() {
    return {
        favoritGoodsList:[],
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {}
    };
  },
 props: ['navTitle','articleList','stype'],
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      this.getCommoditylist()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
         // 商品列表查询
    getCommoditylist() {
      this.loading = true;
      recommendFavorit({
        bXyCommodity:'', // 查全部
        stype:this.stype||'',
        userId:this.userInfo.userId || ''
      })
        .then((res) => {
          this.loading = false;
          this.favoritGoodsList = res.rows.length>10? res.rows.slice(0,10):res.rows          
         
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("查询失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang='less'>
.favoritGoods {
  margin: 40px 0;
}
.el-image.img-responsive.selectItemCss_ls {
    height: 100%;
    border-radius: 8px;
}

.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}
</style>

 
 




// WEBPACK FOOTER //
// src/components/favoritGoods.vue